/**
 * SPDX-FileCopyrightText: © 2014 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: LGPL-3.0-or-later
 */

const tableSelectionGetArrowBoxClasses = function() {
	return 'ae-arrow-box ae-arrow-box-bottom';
};

const SelectionGetArrowBoxClasses = {
	table: tableSelectionGetArrowBoxClasses,
};

export default SelectionGetArrowBoxClasses;
